
export const  POST_REGISTRATION_INFO = 'POST_REGISTRATION_INFO';
export const  POST_REGISTRATION_INFO_SUCCESS = 'POST_REGISTRATION_INFO_SUCCESS';
export const  POST_REGISTRATION_INFO_ERROR = 'POST_REGISTRATION_INFO_ERROR';